import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import Icon from '../Icons'

export const Parking404 = () => {
  const { t } = useTranslation(['parking'])
  return (
    <div className="parking-info">
      <img
        src="/images/logo/elevateos-logo-wide-black.svg"
        className="parking-info__header-logo"
        alt={ELEVATEOS_LOGO_ALT}
      />
      <div className="parking-info__section center darker">
        <Icon icon="search" viewBox="0 0 20 20" styles={{ width: '40px', height: '40px' }} />
        <div className="parking-info__section-title">404</div>
        <div style={{ fontWeight: '600', fontSize: '18px' }}>{t('parking:notFound.title')}</div>
        <div>{t('parking:notFound.body')}</div>
      </div>
    </div>
  )
}

export default Parking404
